import { useContext } from "react";
import { appContext } from "../../navbar/auth";
export default function useLanguage(props) {
  const { setting } = useContext(appContext);
  const language = setting?.language?.toLowerCase() || "english";
  const lang = props[language] || props["english"];
  return lang;
}
